import { getToken, onMessage } from 'firebase/messaging';
import { messaging } from './firebase-config';
import { exportFcmToken } from 'store/pageSlice';
import { store } from 'store';

const VAPID_KEY =
	'BI0Md8nB_V5bOO32Bj912-34pxihHNx-9l4vHgAnzrHBtzq9E9xs4U8MsOdhDdTjN3KSoH0pC6aHbES5DWzVuCs';

export const setupFCMNotifications = async () => {
	try {
		const permission = await Notification.requestPermission();
		if (permission !== 'granted') return;

		const token = await getToken(messaging, {
			vapidKey: VAPID_KEY,
			serviceWorkerRegistration: await navigator.serviceWorker.ready,
		});

		if (!token) return;

		localStorage.setItem('fcm_token', token);

		const payload = {
			device_token: token,
			platform: 'web',
		};

		await store.dispatch(exportFcmToken({ data: payload }));
	} catch (err) {
		console.debug('FCM Setup Error:', err);
	}
};

onMessage(messaging, (payload) => {
	const title = payload?.notification?.title || payload?.data?.title;
	const body = payload?.notification?.body || payload?.data?.body;
	const link = '/temperature-dashboard';

	if (Notification.permission === 'granted') {
		const notification = new Notification(title, {
			body,
			data: { link },
			icon: '/icon.png',
			requireInteraction: true,
		});

		notification.onclick = (event) => {
			event.preventDefault();
			window.location.href = link;
		};
	}
});
